import axios from 'axios';
import { aicaBaseUrl, polusBaseUrl } from '../../utils/axios-interceptor';

export function fetchDataByConfig(payload: any, url: string, httpMethod: string, baseUrl?: string, headers?: Record<string, string>) {
    return axios({
        baseURL: baseUrl ?? aicaBaseUrl,
        url: API_ENDPOINTS[url],
        method: httpMethod,
        [httpMethod === 'POST' ? 'data' : 'params']: {
            ...payload,
        },
        ...(headers && { headers }),
    });
}

export const fetchAllLenderProducts = (payload: any) => {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_ALL_LENDER_PRODUCTS,
        method: 'POST',
        data: payload,
    });
};

export const fetchAllLendersWithConnections = (parentOrgId: string, assesseeOrgId?: string) => {
    return fetchDataByConfig(
        { parentOrgId },
        'GET_ALL_LENDERS',
        'GET',
        undefined,
        assesseeOrgId ? { 'x-requested-organization-id': assesseeOrgId } : undefined,
    );
};

export const getCitiesList = (payload: any) => {
    return fetchDataByConfig(payload, 'GET_ALL_CITIES', 'GET', polusBaseUrl);
};

const API_ENDPOINTS = {
    GET_ALL_LENDERS: '/account/getAllLenders',
    GET_ALL_PRODUCTS: '/unifier/getAllProducts',
    GET_ALL_AVAILABLE_PRODUCTS: '/unifier/getAllProducts',
    GET_ALL_LENDER_PRODUCTS: '/unifier/getAllLenderProducts',
    AICA_GET_ORG_USERS: '/unifier/getOrgUser',
    GET_ALL_CITIES: '/unifier/getCitiesList',
};
